import {combineReducers} from 'redux';
import mappingSetTreeReducer from './mapping-set-tree/reducer';
import mappingSetWizardReducer from "./mapping-set-wizard/reducer";
import {REQUEST_SUCCESS} from "../../../middlewares/api/actions";
import {
    AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY,
    AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY,
    getCustomAnnotationsFromTabsMap,
    getCustomAnnotationsTabsMap,
    getGenericAnnotations,
    isStrCaseInsensitiveEquals,
} from "../../../utils/annotations";
import {getCurrentNodeConfig} from "../../../middlewares/current-node-config/middleware";
import {getCurrentUserPermissions} from "../../../middlewares/current-user-permissions/middleware";
import {
    getArtefactFromSdmxJsonStructure,
    getArtefactTripletFromUrn,
    getSdmxStructuresFromSdmxJson,
    getStringFromArtefactTriplet,
} from "../../../utils/sdmxJson";

import { isDataFlowReadOnly } from './utils';
import {
    DATAFLOW_FORM_SHOW_MAPPING_SET,
    WIZARD_SHOW_MAPPING_SET,
    DATAFLOW_EDIT_VIEW_SHOW,
} from './mapping-set-tree/actions';

import {
    MAPPING_SET_WIZARD_HIDE,
} from './mapping-set-wizard/actions';


import {
    DATAFLOW_TYPE_NORMAL, DATAFLOW_TYPE_ONLY_FILE, DATAFLOW_TYPE_VIRTUAL,
} from "../../../utils/dataflow";
import transcodingReducer from './transcoding/reducer';



const mappingSetIndexReducer = (state = {
    dataflowId: null,
    mappingSetId: null,
    dataflow: {
        id: null,
        agencyID: null,
        version: null,
    }
}, action) => {
    switch (action.type) {
        case DATAFLOW_FORM_SHOW_MAPPING_SET: {
            return {
                ...state,
                dataflowId: action.mappingSetId,
                dataflow: {
                    id: null,
                    agencyID: null,
                    version: null,
                    isFinal: false,
                    uri: null,
                    urn: null,
                    validTo: null,
                    validFrom: null,
                    name: null,
                    description: null,
                    dsd: null,
                    structure: null,
                    annotations: null,
                    dataflowType: DATAFLOW_TYPE_NORMAL,
                    hasToReadDsdSource: false,
                },
                dataflowOriginalAnnotations: undefined,
                isDetailVisible: true,
                isWizardVisible: false,
                isAgenciesValid: false,
                isLinkedDFEndpointAvailable: false,
                linkedDFDataflows: null,
                sourceDataflow: null,
                dsdForLayoutAnnotations: null,
            };
        }
        case MAPPING_SET_WIZARD_HIDE: {
            return {
                ...state,
                dataflowId: action.mappingSetId,
                dataflow: {
                    id: null,
                    agencyID: null,
                    version: null,
                    isFinal: false,
                    uri: null,
                    urn: null,
                    validTo: null,
                    validFrom: null,
                    name: null,
                    description: null,
                    dsd: null,
                    structure: null,
                    annotations: null,
                    dataflowType: DATAFLOW_TYPE_NORMAL,
                    hasToReadDsdSource: false,
                },
                dataflowOriginalAnnotations: undefined,
                isDetailVisible: false,
                isWizardVisible: false,
                isAgenciesValid: false,
                isLinkedDFEndpointAvailable: false,
                linkedDFDataflows: null,
                sourceDataflow: null,
                dsdForLayoutAnnotations: null,
            }
        }
        case REQUEST_SUCCESS:
            switch (action.label) {
                case WIZARD_SHOW_MAPPING_SET: {
                    return {
                        ...state,
                        dataflow: {
                            id: action.dataflowTriplet.type.includes("mappingset") ? action.dataflowTriplet.parentId : action.dataflowTriplet.id,
                            agencyID: action.dataflowTriplet.agencyID,
                            version: action.dataflowTriplet.version,
                        },
                        mappingSetId: action.dataflowTriplet.type.includes("mappingset") ? action.dataflowTriplet.id : null,
                        isWizardVisible: true,
                    }
                }
                case DATAFLOW_EDIT_VIEW_SHOW:


                    const userPermissions = getCurrentUserPermissions(action);
                    const customNoneIsAutoAnnotation = userPermissions && userPermissions.rules.includes("CanManageWorkingAnnotation")
                        ? () => false
                        : undefined;

                    const dataflow = getArtefactFromSdmxJsonStructure(getSdmxStructuresFromSdmxJson(action.response)[0], getCurrentNodeConfig(action).annotations, customNoneIsAutoAnnotation);

                    const annotationTabsConfig = getCurrentNodeConfig(action).annotationTabs.tabs;
                    const annotationsConfig = getCurrentNodeConfig(action).annotations;

                    const linkedDataflowAnnotation = annotationsConfig[AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY];
                    const catalogTypeAnnotation = annotationsConfig[AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY];

                    const isExternalReference = !![
                        ...(dataflow.annotations || []),
                        ...(dataflow.autoAnnotations || [])
                    ].find((ann) => ann && isStrCaseInsensitiveEquals(ann.type, linkedDataflowAnnotation.type));
                    const isOnlyFile = !![
                        ...(dataflow.annotations || []),
                        ...(dataflow.autoAnnotations || [])
                    ].find((ann) => ann && isStrCaseInsensitiveEquals(ann.type, catalogTypeAnnotation.type));
                    return {
                        ...state,
                        dataflow: {
                            ...dataflow,
                            isExternalReference,
                            dataflowType:
                                isExternalReference
                                    ? DATAFLOW_TYPE_VIRTUAL
                                    : (
                                        isOnlyFile
                                            ? DATAFLOW_TYPE_ONLY_FILE
                                            : DATAFLOW_TYPE_NORMAL
                                    ),
                            dsd: dataflow.structure ? getStringFromArtefactTriplet(getArtefactTripletFromUrn(dataflow.structure)) : null,
                            hasToReadDsdSource: (isOnlyFile) ? false : true
                        },
                        selectedDsdTriplet: dataflow.structure ? getArtefactTripletFromUrn(dataflow.structure) : null,
                        isDataflowValid: true,
                        dataflowOriginalAnnotations: [
                            ...getGenericAnnotations(dataflow.annotations, annotationTabsConfig, annotationsConfig),
                            ...getCustomAnnotationsFromTabsMap(getCustomAnnotationsTabsMap(dataflow.annotations, annotationTabsConfig)),
                            (dataflow.autoAnnotations || []).find((ann) =>
                                ann && isStrCaseInsensitiveEquals(ann.type, linkedDataflowAnnotation.type)
                            )
                        ],
                        isLinkedDFEndpointAvailable: null,
                        sourceDataflow: null,
                        dsdForLayoutAnnotations: null,
                        isDetailVisible: true,
                        isWizardVisible: state.isWizardVisible,
                        dataflowTriplet: action.dataflowTriplet,
                        isDataFlowReadOnly:  isDataFlowReadOnly(dataflow),
                    };
                default:
                    return state;
            }
        default:
            return state;
    }
    // switch (action.type) {
    //     default:
    //         return {...state};
    // }
};

const mappingSetReducer = (state = {}, action) => {

    return combineReducers({
        index: mappingSetIndexReducer,
        tree: mappingSetTreeReducer,
        wizard: mappingSetWizardReducer,
        transcoding: transcodingReducer
    })(state, action)

}

export default mappingSetReducer;